<section class="carousel">
    <div class="carousel__container mx-auto">
        <swiper-container
            #swiperContainer
            init="false"
            class="swiperContainer"
        >
            <swiper-slide *ngFor="let product of products; trackBy: trackByFn">
                <app-product-card [data]="product"></app-product-card>
            </swiper-slide>
        </swiper-container>

        <div (click)="swiperContainer.swiper.slidePrev()" class="carousel__swiper__btn carousel__swiper__btn--prev">
            <img src="/assets/icons/left-arrow.svg" alt="left-arrow" loading="lazy" decoding="async" />
        </div>

        <div (click)="swiperContainer.swiper.slideNext()" class="carousel__swiper__btn carousel__swiper__btn--next">
            <img src="assets/icons/right-arrow.svg" alt="rigth-arrow" loading="lazy" decoding="async" />
        </div>
    </div>
</section>

<!-- autoplay-delay="5000" -->